import { AlertColor } from '@mui/material'

class ToastService {
  private showToastCallback:
    | ((message: any, severity?: AlertColor, isException?: boolean) => void)
    | null = null

  registerToast(
    callback: (
      message: any,
      severity?: AlertColor,
      isException?: boolean
    ) => void
  ) {
    this.showToastCallback = callback
  }

  showToast(
    message: any,
    severity: AlertColor = 'info',
    isException: boolean = false
  ) {
    if (this.showToastCallback) {
      this.showToastCallback(message, severity, isException)
    } else {
      console.warn('Erro ao inicializar Toast')
    }
  }
}

export const toastService = new ToastService()
